import React, { FC } from 'react';
import getConfig from 'next/config';

const KlaviyoEmbedForm: FC<{ formId: string; hideHomepage?: boolean; paddingBottom?: string }> = ({
  formId,
  paddingBottom,
}) => {
  const { publicRuntimeConfig } = getConfig();
  const { klaviyoSignupFormEmbed } = publicRuntimeConfig;

  return (
    <>
      <div className={`klaviyo-form-${klaviyoSignupFormEmbed} embed-signup-form`} id={formId} />
      <style jsx>{`
        .embed-signup-form {
          ${paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}
        }
        @media (max-width: 1023px) {
          .embed-signup-form {
            padding-top: 15px;
          }
        }
      `}</style>
    </>
  );
};

export { KlaviyoEmbedForm };
